import { useRef, useEffect, useState } from "react";

const useSolutionsLogic = () => {
  const [screenSize, setScreenSize] = useState("desktop");
  const carouselRef = useRef(null);
  const [dragLimits, setDragLimits] = useState({ left: 0, right: 0 });

  useEffect(() => {
    const updateScreenSize = () => {
      if (window.innerWidth <= 768) {
        setScreenSize("mobile");
      } else if (window.innerWidth <= 1024) {
        setScreenSize("tablet");
      } else {
        setScreenSize("desktop");
      }
    };

    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  useEffect(() => {
    const calculateDragConstraints = () => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const scrollWidth = container.scrollWidth;
        const visibleWidth = container.offsetWidth;
        const maxDrag = scrollWidth - visibleWidth;

        setDragLimits({
          left: -maxDrag,
          right: 0,
        });
      }
    };

    calculateDragConstraints();
    window.addEventListener("resize", calculateDragConstraints);
    return () => window.removeEventListener("resize", calculateDragConstraints);
  }, []);

  return {
    screenSize,
    carouselRef,
    dragConstraints: dragLimits,
  };
};

export default useSolutionsLogic;
